module.exports = __webpack_public_path__ + "img/CM-PW-25-Kia-Lifestyle.2dca9042.jpg";